import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePutReabrir() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putReabrir = useCallback(
        (faturaId: string) =>
            invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Fatura/${faturaId}/reabrir`,
                method: 'PUT',
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putReabrir,
    };
}
